import doorbell from '@/assets/doorbell.mp3'
import bumblebee from '@/assets/Flight-of-the-bumblebee-piano.mp3'

const audio = new Audio(doorbell)

// audio.play() returns a Promise; if a new load() interrupts it the
// browser rejects with AbortError. That's a noisy console error, not a
// real failure (the next play call will succeed). Swallow it.
const safePlay = () => {
  const p = audio.play()
  if (p && typeof p.catch === 'function') p.catch(() => {})
}

const repeatCallback = () => { safePlay() }

export function pauseAudio () {
  audio.pause()
  audio.removeEventListener('ended', repeatCallback, false)
}

export function stopAudio () {
  audio.pause()
  audio.currentTime = 0
}

function play (src, repeat) {
  stopAudio()
  audio.src = src
  safePlay()
  if (repeat) {
    audio.addEventListener('ended', repeatCallback, false)
  } else {
    audio.removeEventListener('ended', repeatCallback, false)
  }
}

export function playDoorbell (repeat) {
  play(doorbell, repeat)
}

export function playBumblebee (repeat) {
  play(bumblebee, repeat)
}

export function playNothing () {
  const src = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
  play(src, false)
}
